import React from 'react'

import { Tag, Descriptions, Row, Col } from 'antd'
import { useCacheService, getServicesById, getCategoriesById } from '../../../hooks/cache/service'
import { useCacheLanguage, getLanguagesById } from '../../../hooks/cache/language'
import { useCacheLanguagePair, getLanguagePairsById } from '../../../hooks/cache/languagePair'
import { useCacheSpecialization, getSpecializationsById } from '../../../hooks/cache/specialization'

const Details = (props) => {
  const { vendor } = props
  const { data: servicesRaw, isLoading: isServiceLoading } = useCacheService()
  const { data: languagesRaw, isLoading: isLanguageLoading } = useCacheLanguage()
  const { data: languagePairsRaw, isLoading: isLanguagePairLoading } = useCacheLanguagePair()
  const { data: specializationsRaw, isLoading: isSpecializationLoading } = useCacheSpecialization()
  const servicesById = getServicesById(servicesRaw)
  const categoriesById = getCategoriesById(servicesRaw)
  const languagesById = getLanguagesById(languagesRaw)
  const languagePairsById = getLanguagePairsById(languagePairsRaw)
  const specializationsById = getSpecializationsById(specializationsRaw)

  if (isServiceLoading || isLanguageLoading || isLanguagePairLoading || isSpecializationLoading) {
    return null
  }

  return (
    <>
      <h2 className='after-underline'>General</h2>
      <Descriptions size='medium' column={3}>
        <Descriptions.Item label='Services' span={3}>
          {(vendor.services || []).map((item) => (
            <Tag key={item}>{servicesById[item]?.name}</Tag>
          ))}
        </Descriptions.Item>

        {(vendor.categories || []).length > 0 && categoriesById && (
          <Descriptions.Item label='Categories' span={3}>
            <Row>
              <Col span={24}>
                {(vendor.categories || []).map((item) => (
                  <Tag key={item}>{categoriesById[item]?.name}</Tag>
                ))}
              </Col>
            </Row>
          </Descriptions.Item>
        )}

        {vendor.language_family && (
          <Descriptions.Item label='Languages Family' span={3}>
            <Tag>{vendor.language_family}</Tag>
          </Descriptions.Item>
        )}

        {(vendor.languages || []).length > 0 && (
          <Descriptions.Item label='Languages' span={3}>
            <Row>
              <Col span={24}>
                {(vendor.languages || []).map((item) => (
                  <Tag key={item}>{languagesById[item]?.name}</Tag>
                ))}
              </Col>
            </Row>
          </Descriptions.Item>
        )}

        {(vendor.language_pairs || []).length > 0 && (
          <Descriptions.Item label='Language Pairs' span={3}>
            <Row>
              <Col span={24}>
                {(vendor.language_pairs || []).map((item) => (
                  <Tag key={item}>{languagePairsById[item]?.name}</Tag>
                ))}
              </Col>
            </Row>
          </Descriptions.Item>
        )}

        {(vendor.specializations || []).length > 0 && (
          <Descriptions.Item label='Specializations' span={3}>
            <Row>
              <Col span={24}>
                {(vendor.specializations || []).map((item) => (
                  <Tag key={item}>{specializationsById[item]?.name}</Tag>
                ))}
              </Col>
            </Row>
          </Descriptions.Item>
        )}
        {vendor.notes && <Descriptions.Item label='Notes'> {vendor.notes} </Descriptions.Item>}
      </Descriptions>
      <br />
      <h2 className='after-underline'>Working Hours</h2>
      <ul>
        {vendor.work_days && (vendor.work_days_grid || []).map((item) => {
          if ((item.ranges || []).length > 0) {
            return (
              <li key={item.name}>
                {item.name.toUpperCase()}:{' '}
                {(item.ranges || []).map((r) => `${r.from} - ${r.to} `).join(', ')}
              </li>
            )
          }
          return null
        })}
      </ul>
    </>
  )
}

export default Details
